// extracted by mini-css-extract-plugin
export default {"notification-container":"styles_notification-container__mDJo5"};